import { Stack, Text, TooltipHost } from "@fluentui/react";
import React, { FC } from "react";
import { HorizontalStack, VerticalStack } from "../../Stack";
import { DocumentWithTrack } from "../NewShareModal";
import { useTranslation } from "react-i18next";
import { Document } from "../../../models";
import Cross from "./icons/Cross";
import PdfIcon from "../../../assets/Icons/svg/pdfIcon";

type SelectedDocumentProps = {
  modal?: string;
  setSelectedDocuments?: React.Dispatch<React.SetStateAction<Document[]>>;
  documentWithTrack: DocumentWithTrack;
  setDocumentWithTrack: React.Dispatch<
    React.SetStateAction<DocumentWithTrack[]>
  >;
  length: number;
};

const PdfTrackCard: FC<SelectedDocumentProps> = (props) => {
  const SelectedDocumentStyles = {
    width: "208px",
    height: "40px",
    padding: "6px 10px",
    alignItems: "center",
    justifyContent: "space-between",
    borderRadius: "6px",
    border: "1px solid var(--LIGHT-BLUE, #FCF0ED)",
    fontFamily: "Poppins",
    fontSize: "9px",
    fontWeight: 500,
    backgroundColor: props.documentWithTrack.includePdf
      ? "#FCF0ED"
      : "#E8ECF4",
  };

  const versionDocumentStyle = {
    padding: "4px",
    justifyContent: "center",
    alignItems: "center",
    gap: "8px",
    borderRadius: "4px",
    border: "1px solid var(--LIGHT-BLUE, #FCF0ED)",
    backgroundColor: "#FFF",
    fontFamily: "Poppins",
    fontSize: "10px",
    fontWeight: 500,
    color: "#A82C0C",
    height: "20px",
  };

  const { t } = useTranslation();

  const handleRemovePdf = () => {
    props?.setDocumentWithTrack((prev) =>
      prev.filter((item) => {
        const isTargetDoc = item.document.rootDocumentId === 
          props.documentWithTrack.document.rootDocumentId;
        
        if (isTargetDoc && item.fileType === "pdf") {
          return false;
        }
        
        if (isTargetDoc) {
          item.includePdf = false;
        }
        
        return true;
      })
    );
  };
  return (
    <HorizontalStack style={{ position: "relative", alignItems: "center" }}>
      {(props.documentWithTrack?.includePdf || props.length > 1) && (
        <div
          style={{
            position: "absolute",
            top: "-7px",
            right: "0",
            transform: "translate(50%, 0)",
            cursor: "pointer",
          }}
          onClick={handleRemovePdf}
          >
          <Cross color={"#A82C0C"} />
        </div>
      )}
      {props.documentWithTrack?.includePdf && (
        <Stack>
          <svg
            width="9"
            height="2"
            viewBox="0 0 9 2"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M0 1H8.5" stroke="#A82C0C" />
          </svg>
        </Stack>
      )}
      <HorizontalStack style={SelectedDocumentStyles}>
        {(() => {
          const isRedlined = props.documentWithTrack.includePdf;
          const content = (
            <HorizontalStack style={{ gap: "8px", alignItems: "center" }}>
              <PdfIcon />
              <VerticalStack style={{ gap: "4px" }}>
                <Text
                  style={{
                    fontFamily: "Poppins",
                    fontSize: "9px",
                    fontWeight: 600,
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    width: "130px",
                    lineHeight: "12px",
                  }}
                  title={props?.documentWithTrack.document?.rootDocumentName}
                >
                  {props?.documentWithTrack.document?.rootDocumentName?.replace(
                    /\.[^/.]+$/,
                    ""
                  )}
                </Text>
                <HorizontalStack style={{ alignItems: "center", gap: "4px" }}>
                  <Text
                    style={{
                      color: isRedlined
                        ? "var(--primary-Red, #A82C0C)"
                        : "blue",
                      fontFamily: "Poppins",
                      fontSize: "9px",
                      lineHeight: "12px",
                      fontWeight: "400",
                    }}
                  >
                    {isRedlined ? t("pdf_track_card_redline") : t("pdf_track_card_document")}
                  </Text>
                </HorizontalStack>
              </VerticalStack>
            </HorizontalStack>
          );

          return isRedlined ? (
            <TooltipHost
              content={t("pdf_track_card_redline_tooltip") || ""}
              calloutProps={{
                isBeakVisible: true,
                beakWidth: 10,
                gapSpace: 5
              }}
            >
              {content}
            </TooltipHost>
          ) : content;
        })()}
        <HorizontalStack style={versionDocumentStyle}>
          {`P${props?.documentWithTrack.document?.version}`}
        </HorizontalStack>
      </HorizontalStack>
    </HorizontalStack>
  );
};

export default PdfTrackCard;
